import { render, staticRenderFns } from "./PH2V.vue?vue&type=template&id=4c82586f&scoped=true"
import script from "./PH2V.vue?vue&type=script&lang=js"
export * from "./PH2V.vue?vue&type=script&lang=js"
import style0 from "./PH2V.vue?vue&type=style&index=0&id=4c82586f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82586f",
  null
  
)

export default component.exports